<template>
  <div class="d-flex justify-end">
    <v-btn class="search-button" outlined color="success" @click="exportExcel">
      <v-icon left>mdi-file-excel</v-icon> Xuất Excel
    </v-btn>
  </div>
</template>
<script>
import { headerExcel } from '@/modules/tuitionFee/detail-period/helper/headerStudent'
import utils from '@/plugins/utils'
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      ownClassIds: 'auth/ownClassIds',
      user: 'auth/user',
      customQuery: 'tuitionFeeReport/customQuery',
      detailPeriod: 'tuitionFeePeriod/detailPeriod'
    })
  },
  methods: {
    ...mapActions({
      exportDataExcel: 'tuitionFeeReport/exportDataExcel',
      fetchChecks: 'tuitionFeeCheck/fetchIndependent'
    }),

    groupAndSortArray(arr) {
      return _(arr)
        .groupBy('class._id')
        .values()
        .flatMap(group => _.sortBy(group, 'student.name'))
        .value()
    },
    renderTransTime(yyyymmddHHMMss = '') {
      if (!yyyymmddHHMMss.length) return ''

      const year = yyyymmddHHMMss.substring(0, 4)
      const month = yyyymmddHHMMss.substring(4, 6)
      const day = yyyymmddHHMMss.substring(6, 8)
      const hours = yyyymmddHHMMss.substring(8, 10)
      const minutes = yyyymmddHHMMss.substring(10, 12)
      const seconds = yyyymmddHHMMss.substring(12, 14)

      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`
    },
    async exportExcel() {
      this.$loading.active = true
      try {
        let params = {
          ...this.customQuery,
          period: this.detailPeriod.id,
          class_in: this.user.role.type === 'teacher' ? this.ownClassIds : null,
          countTicket: false
        }
        let listReport = await this.exportDataExcel(params)
        const listCheck = await this.fetchChecks({ period: this.detailPeriod.id, _limit: -1, kind: 'cen' })

        listReport = this.groupAndSortArray(listReport)
        let filter = this.$options.filters
        const data = listReport.filter(r => r.student).map(item => {
          item.name = item.student.name
          item.code = filter.getStudentCode(item.student.code)
          item.dob = filter.ddmmyyyy(item.student.dob)
          item.gender = filter.gender(item.student.gender)
          item.class = item.class && item.class.title
          item.status = filter.status(item.student.status)
          item.notes = item.notes || ''
          item.totalMoney = item.totalSumFee - item.totalMinusFee
          item.totalMoneyPaid = _.get(item, 'cen.amountPaid', 0) + _.get(item, 'decen.amountPaid', 0)
          item.totalMoneyDebt = _.get(item, 'cen.amountDebt', 0) + _.get(item, 'decen.amountDebt', 0)
          const check = listCheck.find(c => _.get(c, 'report') === item.id)
          if (check) {
            item.transTime = this.renderTransTime(_.get(check, 'data.transTime', ''))
            item.bankTransId = _.get(check, 'data.bankTransId', '')
          }
          return item
        })

        utils.exportExcel(
          data,
          headerExcel,
          `Danh sách học sinh tổng kết kì đóng ${filter.convertFullDate(this.detailPeriod.title)}`
        )
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>
